import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useMemo } from "react";

function Commands({ lid, oca, akas, dobs, socs, sids, smts, cmcs }) {
  const [commands, setCommands] = useState([]);

  let baseString = `EN..LID/${lid}.OCA/${oca}`;

  const information = useMemo(
    () => [
      { type: "AKA", values: akas },
      { type: "DOB", values: dobs },
      { type: "SOC", values: socs },
      { type: "SID", values: sids },
      { type: "SMT", values: smts },
      { type: "CMC", values: cmcs.map((c) => c.slice(0, 2)) },
    ],
    [akas, dobs, socs, sids, smts, cmcs]
  );
useEffect(() => {
  const maxItems = 9;
  const commandsList = [];
  let current = baseString;
  let count = 0;

  for (const { type, values } of information) {
    let remaining = [...values];

    while (remaining.length > 0) {
      const spaceLeft = maxItems - count;
      const chunk = remaining.slice(0, spaceLeft);
      remaining = remaining.slice(chunk.length);

      current += `.${type}/${chunk.join(".")}`;
      count += chunk.length;

      if (count === maxItems) {
        commandsList.push(current);
        current = baseString;
        count = 0;
      }
    }
  }

  if (count > 0) {
    commandsList.push(current);
  }

  setCommands(commandsList);
}, [baseString, information]);


  const copyToClipboard = (command) => {
    navigator.clipboard.writeText(command).then(() => {
      setPopupMessage("Command copied to clipboard");
      setOpen(true);
      console.log("Command copied to clipboard:", command);
    });
  };

  const [open, setOpen] = React.useState(false);
  const [popupMessage, setPopupMessage] = React.useState("");
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {
        <Snackbar
          open={open}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert severity="success" sx={{ width: "100%" }}>
            {popupMessage}
          </Alert>
        </Snackbar>
      }
      {commands.map((command, index) => (
        <TextField
          key={index}
          label={`Command ${index + 1}`}
          variant="standard"
          size="small"
          value={command}
          fullWidth
          multiline
          disabled
          sx={{ mb: 1 }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment>
                  <IconButton
                    edge="start"
                    onClick={copyToClipboard.bind(null, command)}
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      ))}
    </>
  );
}

export default Commands;
